export enum VerificationCriteriaTaskActionStatus {
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
}

export enum VerificationCriteriaTaskCompletionStatus {
  PENDING = 'pending',
  COMPLETED = 'completed',
}

export interface VerificationCriteriaTaskParams {
  id: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  description: string;
  verificationCriteriaId: string;
  actionStatus: VerificationCriteriaTaskActionStatus;
  completionStatus: VerificationCriteriaTaskCompletionStatus;
  propelOrgId: string;
  assignedUserId?: string | null;
}

export interface VerificationCriteriaTaskData {
  id: string;
  createdAt?: string;
  updatedAt?: string;
  description: string;
  verificationCriteriaId: string;
  actionStatus: VerificationCriteriaTaskActionStatus;
  completionStatus: VerificationCriteriaTaskCompletionStatus;
  propelOrgId: string;
  assignedUserId?: string | null;
}

export interface VerificationCriteriaTaskCreateInput {
  description: string;
  actionStatus: VerificationCriteriaTaskActionStatus;
}

export interface VerificationCriteriaTaskUpdateInput {
  id: string;
  description: string;
  actionStatus: VerificationCriteriaTaskActionStatus;
}

export interface VerificationCriteriaTaskBulkCreateData {
  verificationCriteriaId: string;
  description: string;
  actionStatus: VerificationCriteriaTaskActionStatus;
}
